/** Crew pay entry in the portal menu (wording kept with the module). */
export const PAY_NAV = { label: "Crew pay", hint: "Monthly crew invoices" } as const;
